export const LeaderboardMocks = {
	users: [
		{ name: 'Ahad Cove', username: 'ahadcove', bits: 6000, commands: 64 },
		{ name: 'Uimind', username: 'uimind', bits: 4301, commands: 24 },
		{ name: 'Mikael', username: 'covsoche', bits: 1000, commands: 4 },
		{ name: 'Jimmy Mayne', username: 'samwilsontv', bits: 1200, commands: 2 },
		{ name: 'Jake', username: 'meldj', bits: 2000, commands: 10 },
	],
	pointUsers: [
		{ name: 'Ahad Cove', username: 'ahadcove', bits: 6000, points: 6000, commands: 64 },
		{ name: 'Uimind', username: 'uimind', bits: 4301, points: 4301, commands: 24 },
		{ name: 'Mikael', username: 'covsoche', bits: 1000, points: 1000, commands: 4 },
		{ name: 'Sam', username: 'samwilsontv', bits: 1200, points: 1200, commands: 2 },
		{ name: 'Jake', username: 'meldj', bits: 2000, points: 2000, commands: 10 },
	],
	commands: [
		{ name: 'green', submissions: 100, bits: 8000 },
		{ name: 'red', submissions: 52, bits: 4000 },
		{ name: 'blue', submissions: 23, bits: 3000 },
		{ name: 'orange', submissions: 10, bits: 1000 },
		{ name: 'yellow', submissions: 20, bits: 2000 },
		{ name: 'maroon', submissions: 20, bits: 2000 },
		{ name: 'aqua', submissions: 20, bits: 2000 },
		{ name: 'beige', submissions: 20, bits: 2000 },
		{ name: 'black', submissions: 20, bits: 2000 },
		{ name: 'white', submissions: 20, bits: 2000 },
		{ name: 'azul', submissions: 20, bits: 2000 },
	],
};
